"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
exports.default = theme => ({
    root: {
        marginBottom: 14,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start'
    },
    title: {
        color: theme.grey2,
        fontSize: constants_1.MENU_TITLE_FONT_SIZE,
        lineHeight: constants_1.MENU_TITLE_LINE_HEIGHT,
        fontWeight: 400,
        letterSpacing: '1px',
        textTransform: 'uppercase',
        marginRight: 14
    },
    action: {
        flexShrink: 0,
        minHeight: constants_1.MENU_TITLE_FONT_SIZE * constants_1.MENU_TITLE_LINE_HEIGHT,
        display: 'flex',
        alignItems: 'center'
    }
});
//# sourceMappingURL=menu.header.style.js.map